import React from 'react';
import { FadeIn } from './ui';
import { Users, BookOpen, Star, MapPin } from 'lucide-react';
export function SocialProofBar() {
  const stats = [{
    icon: Users,
    value: '+847',
    label: ['DOCENTES', 'TODO EL PAÍS']
  }, {
    icon: BookOpen,
    value: '12',
    label: ['TOMOS LISTOS', 'PARA USAR']
  }, {
    icon: Star,
    value: '4.9/5',
    label: ['CALIFICACIÓN', 'CONFÍAN'],
    highlight: true
  }, {
    icon: MapPin,
    value: '🇦🇷',
    label: ['TODO EL PAÍS', 'PRIM. Y SEC.']
  }];
  const testimonials = [{
    quote: 'Organicé todo el año de Matemática en una tarde. No lo puedo creer.',
    initials: 'MG',
    name: 'MARIELA G.',
    location: 'CÓRDOBA | PRIMARIA'
  }, {
    quote: 'Mis alumnos de secundaria por fin entienden álgebra. El material engancha.',
    initials: 'LP',
    name: 'LAURA P.',
    location: 'ROSARIO | SECUNDARIA'
  }, {
    quote: 'Nunca más llegué a clase sin saber qué dar. Esto cambió todo.',
    initials: 'RM',
    name: 'ROBERTO M.',
    location: 'BUENOS AIRES | PRIM. Y SEC.'
  }];
  return <section className="w-full" data-id="element-243">
      {/* Stats Bar */}
      <div className="bg-brand-green border-y-4 border-brand-gold" data-id="element-244">
        <div className="max-w-[1200px] mx-auto px-4 py-8 md:py-10" data-id="element-245">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4" data-id="element-246">
            {stats.map((stat, i) => {
            const Icon = stat.icon;
            return <FadeIn key={i} delay={i * 0.08} data-id="element-247">
                  <div className="flex flex-col items-center text-center md:border-r md:last:border-r-0 md:border-white/20 px-2" data-id="element-248">
                    <Icon size={28} strokeWidth={1.75} className={`mb-2 ${stat.highlight ? 'text-brand-gold fill-brand-gold' : 'text-white/90'}`} data-id="element-249" />
                    <div className="text-white text-2xl md:text-4xl font-black mb-1 flex items-center gap-1" data-id="element-250">
                      {stat.value}
                      {stat.highlight && <Star size={20} className="text-brand-gold fill-brand-gold" data-id="element-251" />}
                    </div>
                    <div className="text-white/80 text-[10px] md:text-xs font-bold tracking-wider leading-tight" data-id="element-252">
                      <div data-id="element-253">{stat.label[0]}</div>
                      <div data-id="element-254">{stat.label[1]}</div>
                    </div>
                  </div>
                </FadeIn>;
          })}
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className="bg-white py-8 md:py-12 px-4" data-id="element-255">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-256">
          {testimonials.map((t, i) => <FadeIn key={i} delay={0.1 + i * 0.1} data-id="element-257">
              <div className="bg-gray-50 border border-gray-200 rounded-2xl p-5 md:p-6 h-full hover:border-brand-green/40 hover:shadow-md transition-all duration-300" data-id="element-258">
                <div className="flex gap-0.5 mb-3" data-id="element-259">
                  {Array.from({
                length: 5
              }).map((_, idx) => <Star key={idx} size={16} className="text-brand-gold fill-brand-gold" data-id="element-260" />)}
                </div>
                <p className="text-gray-700 text-sm md:text-base italic leading-relaxed mb-4" data-id="element-261">
                  "{t.quote}"
                </p>
                <div className="pt-3 border-t border-gray-200" data-id="element-262">
                  <div className="text-gray-900 font-bold text-sm" data-id="element-263">
                    {t.initials} — {t.name}
                  </div>
                  <div className="text-gray-500 text-xs tracking-wider mt-0.5" data-id="element-264">
                    {t.location}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}